<template>
  <v-app>
    <v-tabs v-model="active" color="primary" dark slider-color="yellow">
      <v-tab :key="2" ripple> {{ $t("surveysPage.surveyTab") }} </v-tab>
      <v-tab-item>
        <v-container fluid>
          <v-layout align-start justify-space-around fill-height gap>
            <v-flex xs6 grow pe-4>
              <v-layout align-start justify-start column xs>
                <v-flex xs12>
                  <h1 class="headline">
                    {{ $t("surveysPage.surveyInformation") }}
                  </h1>
                </v-flex>
                <v-flex xs12 mt-3 grow class="full-width">
                  <v-form ref="form" v-model="form" class="xs12 full-width">
                    <v-flex xs12>
                      <v-text-field
                        outline
                        v-model="model.title"
                        :rules="[rules.required]"
                        :label="$t('surveysPage.surveyTitleField')"
                        type="text"
                        grow
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        outline
                        v-model="model.question"
                        :rules="[rules.required]"
                        :label="$t('surveysPage.surveyQuestionField')"
                        type="text"
                        grow
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <vue-tags-input
                        :allow-edit-tags=true
                        :avoid-adding-duplicates=true
                        :placeholder="$t('surveysPage.surveyOptions')"
                        v-model="tag"
                        :rules="[rules.required]"
                        :tags="tags"
                        @tags-changed="newTags => tags = newTags"
                      />
                    </v-flex>
                    <v-flex xs12>
                      <ChooseDate
                        :label="$t('surveysPage.surveyEndDate')"
                        v-model="model.date"
                        :rules="[rules.required]"
                      />
                    </v-flex>
                    <v-flex xs12>
                      <ChooseTime
                        :label="$t('surveysPage.surveyEndTime')"
                        v-model="model.time"
                        :rules="[rules.required]"
                      />
                    </v-flex>
                    <v-flex xs12 align-end>
                    <v-btn
                      @click="addSurvey"
                      :loading="loading"
                      color="secondary"
                      >{{ $t("surveysPage.createSurvey") }}</v-btn
                    >
                  </v-flex>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-tab-item>
    </v-tabs>
  </v-app>
</template>
<script>
import axios from "axios";
import ChooseTime from "@/components/monaco/input/ChooseTime";
import ChooseDate from "@/components/monaco/input/ChooseDate";
import VueTagsInput from "@johmun/vue-tags-input";

export default {
  name: "addSurvey",
  title() {
    return this.$t("surveysPage.createSurveyTitle");
  },
  components: {
    ChooseDate,
    VueTagsInput,
    ChooseTime,
  },
  created() {
    // console.log(this.$route.params.id);
  },
  data: () => ({
    active: 0,
    tag: "",
    tags: [],
    loading: false,
    error: false,
    searchQuery: null,
    selectedOptions: [],
    model: {
      //survey
      title: "",
      question: "",
      date: "",
      time: "",
      end_date: "",
      options: [],
    },

    form: false,
    isLoading: false,
  }),
  computed: {
    rules() {
      return {
        email: (v) => !!(v || "").match(/@/) || this.$t("surveysPage.ruleEmail"),
        length: (len) => (v) =>
          (v || "").length >= len ||
          this.$t("surveysPage.ruleLength", { len }),
        password: (v) =>
          !!(v || "").match(/^.{8,15}$/) ||
          this.$t("surveysPage.rulePassword"),
        phoneNumber: (v) =>
          (!!v &&
            v.search(
              /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
            ) !== -1) ||
          this.$t("surveysPage.rulePhone"),

        required: (v) => !!v || this.$t("surveysPage.ruleRequired"),
        numberOfLicense: (v) =>
          !!(v || "").match(/^[0-9]*$/) || this.$t("surveysPage.ruleLicense"),
      };
    },
  },
  mounted() {},

  methods: {
    addSurvey() {
      if (this.$refs.form.validate()) {
        const formData = new FormData();
        const docsFormData = new FormData();

        // const formData=new FormData();
        // const formData=new FormData();
        // this.model.gender = this.model.gender === "Male" ? 0 : 1;
        this.loading = true;
        console.log("tag: "+this.tag.text);
        this.tags.forEach((tag) => {
          formData.append("options[]", tag.text);
        });
        formData.append("title",this.model.title);
        formData.append("question", this.model.question);
        formData.append("end_date", this.model.date+" "+ this.model.time);
        console.log("formData" + formData);
        this.axios
          .post(this.api.ACTIONS.SURVEYS, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            provider: "users",
          })
          .then(() => {
            window.getApp.$emit(
              "SHOW_TOAST",
              this.$t("surveysPage.toastSurveyAdded"),
              "green"
            );
            this.$router.push(`/surveys`);
          })
          .catch((err) => {
            console.log(err.message);
            this.error = true;
            let response = err.response;
            if (response) {
              window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
              console.log(response.data);
            } else {
              window.getApp.$emit(
                "SHOW_TOAST",
                this.$t("surveysPage.toastCheckInfo"),
                "red"
              );
            }
          })
          .then(() => (this.loading = false));

      }
    },
  },
};
</script>
<style lang="css">
  /* style the background and the text color of the input ... */
  .vue-tags-input {
    background: #324652;
    width: 100%;
    max-width: none !important;
  }
  
  .vue-tags-input .ti-new-tag-input {
    background: transparent;
    width: 100%;
    color: #b7c4c9;
  }
  
  .vue-tags-input .ti-input {
    background: #fafafa;
    padding: 14px 10px;
    width: 100%;
    border-radius: 4px;
    border: 1px solid black;
    transition: border-bottom 200ms ease;
  }

  /* we cange the border color if the user focuses the input */
  .vue-tags-input.ti-focus .ti-input {
    border: 1px solid #FF5252;
  }

  /* some stylings for the autocomplete layer */
  .vue-tags-input .ti-autocomplete {
    background: #283944;
    border: 1px solid #8b9396;
    border-top: none;
  }

  /* the selected item in the autocomplete layer, should be highlighted */
  .vue-tags-input .ti-item.ti-selected-item {
    background: #ebde6e;
    color: #283944;
  }

  /* style the placeholders color across all browser */
  .vue-tags-input ::-webkit-input-placeholder {
    color: #a4b1b6;
  }

  .vue-tags-input ::-moz-placeholder {
    color: #a4b1b6;
  }

  .vue-tags-input :-ms-input-placeholder {
    color: #a4b1b6;
  }

  .vue-tags-input :-moz-placeholder {
    color: #a4b1b6;
  }

  /* default styles for all the tags */
  .vue-tags-input .ti-tag {
    position: relative;
    background: #ebde6e;
    color: #283944;
    overflow: hidden;
  }

  /* we defined a custom css class in the data model, now we are using it to style the tag */
  .vue-tags-input .ti-tag.custom-class {
    background: transparent;
    border: 1px solid #ebde6e;
    color: #ebde6e;
    margin-inline-end: 4px;
    border-radius: 0px;
    font-size: 13px;
  }

  /* the styles if a tag is invalid */
  .vue-tags-input .ti-tag.ti-invalid {
    background-color: #e88a74;
  }

  /* if the user input is invalid, the input color should be red */
  .vue-tags-input .ti-new-tag-input.ti-invalid {
    color: #e88a74;
  }

  /* if a tag or the user input is a duplicate, it should be crossed out */
  .vue-tags-input .ti-duplicate span,
  .vue-tags-input .ti-new-tag-input.ti-duplicate {
    text-decoration: line-through;
  }

  /* if the user presses backspace, the complete tag should be crossed out, to mark it for deletion */
  .vue-tags-input .ti-tag:after {
    transition: transform .2s;
    position: absolute;
    content: '';
    height: 2px;
    width: 108%;
    inset-inline-start: -4%;
    top: calc(50% - 1px);
    background-color: #000;
    transform: scaleX(0);
  }

  .vue-tags-input .ti-deletion-mark:after {
    transform: scaleX(1);
  }
</style>